import { Rail } from "@circle-react-uikit/Rail";
import { useRailbar } from "@circle-react/hooks/chatsV2/useRailbar";
import { createPortal } from "react-dom";

interface RailBarPortalProps {
  children: React.ReactNode;
  isFullWidth?: boolean;
  isLoading?: boolean;
  loaderVariant?: "rail-profile" | "rail-member-list";
  noBorderLeft?: boolean;
  position?: "header" | "content" | "portal" | "drawer";
}

export const RailBarPortal = ({
  position = "header",
  children,
  isLoading,
  ...props
}: RailBarPortalProps) => {
  const { shouldShowRailBar = true } = useRailbar();

  const selectorQuery = `#rail-bar-${position}`;
  const portalElement = document.querySelector(selectorQuery);

  if (!portalElement || !shouldShowRailBar) {
    return null;
  }

  return createPortal(
    <Rail isLoading={isLoading} {...props}>
      {children}
    </Rail>,
    portalElement,
  );
};
